export default {
  assignoperators: {
    title: "Assignment of operators to packs delivery",
    topRow: {
      userCode: "Operator",
      worked: "working",
      onPositions: "on positions"
    },
    receipts: {
      modal: {
        title: "Pack info"
      },
      form: {
        summa: {
          title: "Total"
        },
        datebank: {
          title: "Bank date"
        },
        quantity: {
          title: "Receipts"
        },
        countband: {
          title: "Parcels"
        },
        reasonname: {
          title: "Reason for return"
        }
      }
    },
    freePacksColumn: {
      headers: {
        freePacks: "Free packs"
      }
    },
    assignedPacksColumn: {
      headers: {
        assignedPacks: "Packs assigned to the operator"
      }
    },
    packsCountbandColumn: {
      headers: {
        packsCountband: "Parcels"
      }
    },
    packsQuantityColumn: {
      headers: {
        packsQuantity: "Receipts"
      }
    },
    operatorForm: {
      userCode: {
        msg: "Packs assigned to the operator"
      }
    },
    statusInfoPack: {
      pack: "Pack",
      wasPosting: "was posted",
      title: "successfully"
    },
    assignBtn: {
      confirm: {
        assignOperator: "Assign operator",
        toWorkWithPack: "to work with this pack",
        title: "Assignment"
      }
    },
    unassignBtn: {
      confirm: {
        unassignOperator: "Unassign operator",
        fromWorkWithPack: "from working with the pack",
        title: "Release"
      }
    }
  }
};
